import { TransProp } from "@icc/shared/helpers";
import { GuideCap } from "./guide-cap";

/** Zaślepki/zatyczki prowadnic */
export class GuidesCaps {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /**
     * Lewa zaślepka
     *
     * Gdy nie ma prowadzenia (jest przystosowanie) jest ustawione na `null`
     */
    @TransProp()
    left: GuideCap | null;
    /**
     * Prawa zaślepka
     *
     * Gdy nie ma prowadzenia (jest przystosowanie) jest ustawione na `null`
     */
    @TransProp()
    right: GuideCap | null;
}
